import { useState } from 'react'

import { viewVisibilities } from '@/common/components/FilterViews/ViewVisibilityFields/constants'
import useViewVisibility from '@/common/components/FilterViews/ViewVisibilityFields/hooks/useViewVisibility/useViewVisibility'

const useCreateViewForm = ({ initialName, groups, fixedGroupIds, canSelectGroups, onSave }) => {
  const [name, setName] = useState(initialName)
  const viewVisibility = useViewVisibility({
    initialVisibility: viewVisibilities.private,
    initialSelectedGroupIds: fixedGroupIds,
    groups,
    fixedGroupIds,
    canSelectGroups,
  })

  const handleChangeName = e => setName(e.target.value)

  const isFormValid = Boolean(name.trim()) && viewVisibility.isVisibilityValid

  const handleSave = () => {
    const trimmedName = name.trim()

    onSave({ name: trimmedName, sharedWithGroups: viewVisibility.sharedWithGroups })
  }

  return {
    name,
    handleChangeName,
    ...viewVisibility,
    isFormValid,
    handleSave,
  }
}

export default useCreateViewForm
